import { AlertCircle } from 'lucide-react';
import { Spinner } from '@/components/ui';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

/**
 * Reusable error state component with optional retry button.
 */
export function ErrorState({
  title = 'Something went wrong',
  message = 'Failed to load data. Please try again.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-red-400">
      <AlertCircle className="w-10 h-10 mb-3" />
      <p className="text-sm font-medium text-red-600">{title}</p>
      <p className="text-xs text-red-400 mt-1 max-w-xs text-center">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 flex items-center gap-2 px-4 py-2 border border-red-200 text-red-600
                     rounded-md text-sm font-medium hover:bg-red-50 transition-colors"
        >
          <Spinner size="sm" className="w-3.5 h-3.5" />
          Retry
        </button>
      )}
    </div>
  );
}
